
import { useState } from 'react';

const faqs = [
  {
    category: 'Recharge',
    question: 'How long does airtime recharge take?',
    answer:
      "Airtime recharge is instant. Once your payment is confirmed, the airtime is delivered to the recipient's number within seconds. If there's a delay, please wait up to 5 minutes before contacting support.",
  },
  {
    category: 'Recharge',
    question: 'Can I recharge for someone else?',
    answer:
      "Yes! Simply enter the recipient's phone number when making a recharge. You can top up airtime or data for any Nigerian mobile number across all networks.",
  },
  {
    category: 'Bills',
    question: 'What bills can I pay on VTU App?',
    answer:
      'You can pay for Cable TV subscriptions (DSTV, GOtv, StarTimes), electricity bills (prepaid and postpaid meters), and more services coming soon including internet and water bills.',
  },
  {
    category: 'Bills',
    question: 'What if my bill payment fails?',
    answer:
      "If a bill payment fails, your wallet will be refunded automatically within 5-30 minutes. If you don't receive a refund after 30 minutes, please contact our support team with your transaction reference.",
  },
  {
    category: 'Wallet',
    question: 'How do I fund my wallet?',
    answer:
      'You can fund your wallet via bank transfer, debit card, or USSD. Go to Dashboard > Fund Wallet and select your preferred method. Bank transfers are confirmed within 1-5 minutes.',
  },
  {
    category: 'Wallet',
    question: 'Is there a minimum or maximum wallet balance?',
    answer:
      'The minimum funding amount is ₦100. Your maximum wallet balance is ₦500,000 for verified accounts and ₦50,000 for unverified accounts. Verify your account to enjoy higher limits.',
  },
  {
    category: 'Referrals',
    question: 'How does the referral program work?',
    answer:
      'Share your unique referral code with friends. When they sign up and complete their first transaction, you earn ₦200 and they get ₦100 bonus. The more you refer, the higher your reward tier!',
  },
  {
    category: 'Referrals',
    question: 'When do I receive my referral bonus?',
    answer:
      'Your referral bonus is credited to your wallet once your referred friend completes their first transaction (recharge or bill payment of at least ₦500). Pending referrals are shown in your Rewards page.',
  },
  {
    category: 'Account',
    question: 'How do I reset my password?',
    answer:
      "Go to Account > Security > Change Password. Enter your current password and set a new one. If you've forgotten your password, use the \"Forgot Password\" option on the login screen to reset via email or phone.",
  },
  {
    category: 'Account',
    question: 'How do I enable two-factor authentication?',
    answer:
      "Go to Account > Security and toggle on Two-Factor Authentication. You'll receive a verification code via SMS each time you log in for added security.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Recharge', 'Bills', 'Wallet', 'Referrals', 'Account'];

  const filteredFaqs = activeCategory === 'All'
    ? faqs
    : faqs.filter((f) => f.category === activeCategory);

  return (
    <div>
      {/* Category Filter */}
      <div className="flex gap-2 mb-4 overflow-x-auto pb-1 scrollbar-hide">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => {
              setActiveCategory(cat);
              setOpenIndex(null);
            }}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeCategory === cat
                ? 'bg-navy-600 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* FAQ List */}
      <div className="space-y-2">
        {filteredFaqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-gray-900 pr-4">{faq.question}</span>
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i
                  className={`ri-arrow-down-s-line text-gray-400 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </div>
            </button>
            {openIndex === index && (
              <div className="px-4 pb-4 md:px-5 md:pb-5 -mt-1">
                <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
